import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgxSpinnerModule } from "ngx-spinner";
import { ConfirmationDialogComponent } from './_shared/confirmation-dialog/confirmation-dialog.component';
import { ExcelUploadComponent } from './_shared/excel-upload/excel-upload.component';
import { FooterComponent } from './_shared/footer/footer.component';
import { HeaderComponent } from './_shared/header/header.component';
import { LayoutComponent } from './_shared/layout/layout.component';
import { MenusComponent } from './_shared/menus/menus.component';
import { ModalPopupAlertComponent } from './_shared/modal-popup-alert/modal-popup-alert.component';
import { SessionRefreshDialogComponent } from './_shared/session-refresh-dialog/session-refresh-dialog.component';
import { SpinnerComponent } from './_shared/spinner/spinner.component';
import { AdminComponent } from './admin/admin/admin.component';
import { AssignContractComponent } from './admin/assign-contract/assign-contract.component';
import { SetApproveddateComponent } from './admin/set-approveddate/set-approveddate.component';
import { SetComplianceComponent } from './admin/set-compliance/set-compliance.component';
import { SetThresholdComponent } from './admin/set-threshold/set-threshold.component';
import { UserManagementComponent } from './admin/user-management/user-management.component';
import { ErrorComponent } from './error/error.component';
import { HomeComponent } from './home/home.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { AgingReportComponent } from './reports/aging-report/aging-report.component';
import { DropAnalysisComponent } from './reports/drop-analysis/drop-analysis.component';
import { DropAnalysisContractComponent } from './reports/drop-analysis-contract/drop-analysis-contract.component';
import { DropCommentReportComponent } from './reports/drop-comment-report/drop-comment-report.component';
import { LogReportComponent } from './reports/log-report/log-report.component';
import { OpexAccrualReportComponent } from './reports/opex-accrual-report/opex-accrual-report.component';
import { PaymentDetailReportsComponent } from './reports/payment-detail-reports/payment-detail-reports.component';
import { SearchComponent } from './reports/search/search.component';
import { VowdReportComponent } from './reports/vowd-report/vowd-report.component';
import { AddVowdComponent } from './user/add-vowd/add-vowd.component';
import { AssignUserOnBehalfComponent } from './user/assign-user-on-behalf/assign-user-on-behalf.component';
import { EnterVowdComponent } from './user/enter-vowd/enter-vowd.component';
import { ValidationComponent } from './user/validation/validation.component';
import { VowdCommentComponent } from './user/vowd-comment/vowd-comment.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BnNgIdleService } from 'bn-ng-idle';
import { ConfirmationDialogService } from './_services/confirmation-dialog.service';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { AutoCompleteService } from './_services';
import { GlobalDataService } from './_shared';
import { GoogleChartsModule } from 'angular-google-charts';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxPaginationModule } from 'ngx-pagination';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr'; 
import { CalAngularModule } from '@cvx/cal-angular';
import { NumericDirective } from './_shared/numeric.directive';
import { GrdFilterPipe } from './_shared/grd-filter.pipe';
import { environment } from '../environments/environment';
import { AuthInterceptor } from './_helper/error.interceptor';
import { AuthenticationInitializerService } from './_services/authentication-initializer.service';


export function AccessTokenInitializer(authInitService :AuthenticationInitializerService){
  let scopes = environment.calConfig.scopes;
  return () => {
    return authInitService.checkAccount().then((isUserLoggedIn:boolean) => {
      if(isUserLoggedIn){
        return authInitService.getCALAccessToken().then(()=>{
        })
      }else{
        return;
      }
    })
  }
}
@NgModule({
  declarations: [
    AppComponent,
    ConfirmationDialogComponent,
    ModalPopupAlertComponent,
    HomeComponent,
    AdminComponent,
    DropAnalysisContractComponent,
    AssignContractComponent,
    SessionRefreshDialogComponent,
    PaymentDetailReportsComponent,
    GrdFilterPipe,
    ExcelUploadComponent,
    NotFoundComponent,
    AssignUserOnBehalfComponent,
    HeaderComponent,
    FooterComponent,
    MenusComponent,
    LayoutComponent,
    AddVowdComponent,
    SpinnerComponent,
    EnterVowdComponent,
    SetComplianceComponent,
    UserManagementComponent,
    ValidationComponent,
    SetThresholdComponent,
    VowdCommentComponent,
    DropAnalysisComponent,
    SearchComponent,
    OpexAccrualReportComponent,
    AgingReportComponent,
    NumericDirective,
    DropCommentReportComponent,
    LogReportComponent,
    VowdReportComponent,
    SetApproveddateComponent,
    ErrorComponent
  ],
  imports: [
    AppRoutingModule,
    CommonModule,
    HttpClientModule,
    CalAngularModule.forRoot(environment.calConfig
      ),
    // DataTableModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    NgbModule,
    NgxPaginationModule,
    GoogleChartsModule,
   
    ToastrModule.forRoot(
      
    ),
    NgxSpinnerModule.forRoot() ,
    

  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
  providers: [
     { provide: APP_INITIALIZER, useFactory: AccessTokenInitializer, multi: true, deps: [AuthenticationInitializerService] },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    GlobalDataService,ConfirmationDialogService,AutoCompleteService,
    CurrencyPipe,BnNgIdleService,
    provideClientHydration()
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
